import { ComponentType } from 'react'
// import Integrations from '../components/Integrations/Integrations'
import UserManagement from '../components/UserManagement'
import Organizations from '../components/Organizations'
import UnverifiedUserPage from '../components/Miscellaneous/UnverifiedUserPage'
import DTStudio from '../components/DTStudio'
import UserGroups from '../components/UserGroups'
import UsersListInGroup from '../components/UserGroups/UsersListInGroup'
import FMTabs from '../components/Applications/FacilityManagement/FMTabs'
import { Auth0CallbackPage } from '../components/Miscellaneous/Auth0CallbackPage'
import InTransitTabs from '../components/Applications/Intransit'
import Empty from '../components/Layout/SideNav/Empty'
import { RoutePaths, UserPermissions } from '../constants/constants'
import Analytics from '../components/Applications/Analytics'
import ViewAnalytics from '../components/Applications/Analytics/ViewAnalytics'
import Programs from '../components/Programs'
import ViewEntity from '../components/ViewEntity'
import ShipmentSearchGuest from '../components/Applications/GuestApps/ShipmentSearchGuest'
import { ShipmentPreviewGuest2 } from '../components/Applications/GuestApps/ShipmentPreviewGuest'
import Home from '../components/Layout/MainContent/Home'
import DeviceManager from '../components/Applications/DeviceManager'
import UploadManager from '../components/Applications/UploadManager'
import EntityPage from '../components/EntityPage'
// import Flashtrak from '../components/Applications/FlashTrak'
//Below is a test componet. Not part of application
// import CardComponent from '../components/Test/CardLayout/CardComponent'

export interface RoutesType {
    path: string
    exact: boolean
    component: ComponentType
    requiredAuthGuard: boolean
    permissions: UserPermissions[]
    hasPermission: boolean
    redirectPath?: string
}

const initialRoutes: RoutesType[] = [
    {
        path: RoutePaths.Home,
        exact: true,
        component: Home,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/entity/:templateName/:templateId',
        exact: true,
        component: EntityPage,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.entityPreview,
        exact: true,
        component: ViewEntity,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/admin/:templateName/:templateId',
        exact: true,
        component: EntityPage,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.ORG_ADMIN,
            UserPermissions.SYSTEM_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: '/insurance',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: '/coc',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: '/doc-management',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.userManagement,
        exact: true,
        component: UserManagement,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.userGroups,
        exact: true,
        component: UserGroups,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: '/user-group/:groupName/:groupId',
        exact: true,
        component: UsersListInGroup,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.organizations,
        exact: true,
        component: Organizations,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.programs,
        exact: true,
        component: Programs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.unverifiedUser,
        exact: true,
        component: UnverifiedUserPage,
        requiredAuthGuard: false,
        permissions: [],
        hasPermission: true,
    },
    {
        path: RoutePaths.dtStudio,
        exact: true,
        component: DTStudio,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
        redirectPath: RoutePaths.networkAdmin,
    },
    {
        path: RoutePaths.networkAdmin,
        exact: true,
        component: DTStudio,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    // {
    //     path: RoutePaths.flashtrak,
    //     exact: true,
    //     component: Flashtrak,
    //     requiredAuthGuard: true,
    //     permissions: [UserPermissions.ENTITY_READER,
    //     hasPermission: false,
    // },
    {
        path: RoutePaths.facilityMonitoring,
        exact: true,
        component: FMTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/callback',
        exact: true,
        component: Auth0CallbackPage,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.analytics,
        exact: true,
        component: Analytics,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.analyticsPreview,
        exact: true,
        component: ViewAnalytics,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.inTransit,
        exact: true,
        component: InTransitTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
        redirectPath: RoutePaths.ccl,
    },
    {
        path: RoutePaths.ccl,
        exact: true,
        component: InTransitTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.guestUserShipment,
        exact: true,
        component: ShipmentSearchGuest,
        requiredAuthGuard: false,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: true,
    },
    {
        path: '/guestUser/shipment/:shipmentId',
        exact: true,
        component: ShipmentPreviewGuest2,
        requiredAuthGuard: false,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: true,
    },
    {
        path: RoutePaths.deviceManager,
        exact: true,
        component: DeviceManager,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.DEVICE_WRITER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.uploadManager,
        exact: true,
        component: UploadManager,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
]

export default initialRoutes
